import { parseJSON } from '@barboxx/utils';

const safeParseStoredValue = <T>(value: string): T => {
    // Generated by Copilot
    try {
        return parseJSON(value) as T;
    } catch {
        return value as T;
    }
};

export const getStoredValues = async <K extends string, T>(
    keys: K[]
): Promise<Record<K, T>> => {
    const data: Record<K, T> = {} as Record<K, T>;
    for (const key of keys) {
        const value = window.localStorage.getItem(key);
        if (value) {
            data[key] = safeParseStoredValue<T>(value);
        }
    }
    return data;
};

export const setStoredValues = async <T = unknown>(data: Record<string, T>) => {
    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            const value = JSON.stringify(data[key]);
            window.localStorage.setItem(key, value);
        }
    }
};

export const clearStoredValues = async (keys: string[]) => {
    for (const key of keys) {
        window.localStorage.removeItem(key);
    }
};
